import { HoverMenu, HoverMenuContent, HoverMenuItem, HoverMenuTrigger } from "@/app/common/common-components/ui/HoverMenu";
import { Cog, HelpCircle, LogOut, User } from "lucide-react";
import { ReactNode, useState } from "react";
import { NavLink } from "react-router";
import HelpDialog from "@/features/header/components/HelpDialog";

type UserMenuProps = {
  children: ReactNode;
  userId?: string;
  isLoginAs?: boolean;
  logout?: () => void;
};

const UserMenu = ({ children, userId, isLoginAs, logout }: UserMenuProps) => {
  const [open, setOpen] = useState(false);
  const [isHelpDialogOpen, setIsHelpDialogOpen] = useState(false);

  const handleMenuItemClick = (callback: () => void) => {
    setOpen(false);
    callback();
  };

  return (
    <>
      <HelpDialog open={isHelpDialogOpen} onOpenChange={setIsHelpDialogOpen} />
      <HoverMenu open={open} onOpenChange={setOpen} openDelay={0} closeDelay={100}>
        <HoverMenuTrigger
          asChild
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setOpen(true);
          }}
        >
          {children}
        </HoverMenuTrigger>
        <HoverMenuContent side="bottom" align="start" sideOffset={0} className="tw-rounded-t-none">
          <NavLink to={`/Settings/SaveUser/${userId}`} className="tw-text-foreground tw-no-underline hover:tw-no-underline" onClick={() => setOpen(false)}>
            <HoverMenuItem className="tw-flex tw-items-center tw-gap-2">
              <User className="tw-size-4" />
              My Profile
            </HoverMenuItem>
          </NavLink>
          <NavLink to="/Settings" className="tw-text-foreground tw-no-underline hover:tw-no-underline" onClick={() => setOpen(false)}>
            <HoverMenuItem className="tw-flex tw-items-center tw-gap-2">
              <Cog className="tw-size-4" />
              Settings
            </HoverMenuItem>
          </NavLink>
          <HoverMenuItem className="tw-flex tw-items-center tw-gap-2" onClick={() => handleMenuItemClick(() => setIsHelpDialogOpen(true))}>
            <HelpCircle className="tw-size-4" />
            Help
          </HoverMenuItem>
          {logout && (
            <HoverMenuItem className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2" onClick={() => handleMenuItemClick(logout)}>
              <LogOut className="tw-size-4" />
              {isLoginAs ? "Sign Out (as)" : "Sign Out"}
            </HoverMenuItem>
          )}
        </HoverMenuContent>
      </HoverMenu>
    </>
  );
};

export default UserMenu;
